enum TransactionAttachmentType {
  RECEIPT = 'RECEIPT',
  EFAKTURA = 'EFAKTURA',
  DIGIPOST = 'DIGIPOST',
  AVTALEGIRO = 'AVTALEGIRO',
}

export default TransactionAttachmentType;
